import React, { FC, CSSProperties, ReactNode } from 'react';

import { Box } from '@adsk/alloy-react-box';
import { WithAlloySuspense } from '@adsk/alloy-react-suspense';
import theme from '@adsk/alloy-react-theme';

type AttachmentsContainerProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

const AttachmentsContainer: FC<AttachmentsContainerProps> = ({
  children,
  style,
  ...props
}) => {
  return (
    <Box
      data-testid="AttachmentsContainer"
      minWidth="250px"
      border={`1px solid ${theme.colors.charcoal200}`}
      borderRadius="4px"
      style={style}
      {...props}
    >
      {children}
    </Box>
  );
};

export default WithAlloySuspense(AttachmentsContainer);
